// 화면관리(SY13) 화면 상수 — 뷰·배선(index.tsx)이 같이 쓴다.

/** 라우트 메뉴코드(소문자) — 권한 조회와 쿼리 키 맨 앞(탭 닫기 캐시 삭제)이 같은 값을 쓴다 */
export const MENU_CODE = 'sy13'

/** 표 id — 위에서부터 HEAD(MOMS_PROG_INFO) → ITEM(MOMS_GRID_OPT_INFO) → SUB(MOMS_GRID_COLUMN_INFO) */
export const HEAD = 'sy13HeadTable'
export const ITEM = 'sy13ItemTable'
export const SUB = 'sy13SubTable'
export type TableId = typeof HEAD | typeof ITEM | typeof SUB
export const TABLE_IDS: readonly TableId[] = [HEAD, ITEM, SUB]

/** 화면관리 그리드 설정 — 표 id → gridCd(docs/conventions/grid-code.md). 개인 컬럼 배치 저장도 같은 값을 쓴다 */
export const GRID_CDS = { [HEAD]: 'SY13_HEAD', [ITEM]: 'SY13_ITEM', [SUB]: 'SY13_SUB' } as const

/** 표 페이지 크기 — '몇 개씩' 미노출 = 10,000개씩(MOMS·MWMS 공통 규칙 2026-08-24, 1.0 SY03 paginationPageSize 도 10000) */
export const SY13_PAGE_SIZE = 10000

/** 확인창·토스트 문구에 쓰는 표 이름 */
export const TABLE_NOUN: Record<TableId, string> = { [HEAD]: '메뉴', [ITEM]: '그리드', [SUB]: '칼럼' }

/** BE 가 비면 400 으로 거부하는 칸 — 화면관리 설정이 필수를 꺼도 [저장] 이 막는다 */
export const BE_REQUIRED: Record<TableId, ReadonlySet<string>> = {
  [HEAD]: new Set(['SPR_NM', 'MENU_CD']),
  [ITEM]: new Set(['GRID_CD']),
  [SUB]: new Set(['COLUMN_CD']),
}
/** [저장] 필수 검사 후보 — 저장 본문에 실리는 글자 칸. required 는 화면관리 설정이 없을 때 값(1.0 SY03 COLUMN_REQ) */
export const SAVE_REQUIRED: Record<TableId, { dataIndex: string; title: string; required?: boolean }[]> = {
  [HEAD]: [
    { dataIndex: 'SPR_NM', title: '화주코드', required: true },
    { dataIndex: 'MENU_CD', title: '메뉴코드', required: true },
    { dataIndex: 'MENU_NM', title: '메뉴명', required: true },
  ],
  [ITEM]: [{ dataIndex: 'GRID_CD', title: '그리드코드', required: true }],
  [SUB]: [
    { dataIndex: 'COLUMN_CD', title: '칼럼코드', required: true },
    { dataIndex: 'COLUMN_PRESET', title: '프리셋' },
  ],
}

export const MESSAGES = {
  noSelection: '저장할 행을 선택해 주세요.',
  requiredCells: (titles: string[]) => `${titles.join('·')} 칸은 필수입니다.`,
  apiFailed: (status?: number) => (status ? `요청을 처리하지 못했습니다(HTTP ${status}). 잠시 후 다시 시도하세요.` : '요청을 처리하지 못했습니다. 잠시 후 다시 시도하세요.'),
  partialFailed: (total: number, done: number, reason: string) => `${total}건 중 ${done}건 반영 후 실패했습니다. ${reason}`,
  cascade: (grids: number, columns: number) => `함께 삭제: 그리드 ${grids}건 · 칼럼 ${columns}건`,
  itemCascade: '같은 그리드의 칼럼 설정도 함께 삭제됩니다.',
} as const
